jQuery(document).ready(function($){

	// const imageCoatBox = $("#section-3-row #image-coat");
 //    const imageCoat = $("#section-3-row #image-coat img");

 	if ( $('.home_jackets_section').length ) {

 		const content1 = $(".feature-row__item_item.feature-row__item_item_1");
	    const content2 = $(".feature-row__item_item.feature-row__item_item_2");
	    const content3 = $(".feature-row__item_item.feature-row__item_item_3");
	    const content4 = $(".feature-row__item_item.feature-row__item_item_4");
        const content5 = $(".feature-row__item_item.feature-row__item_item_5");
	    const counter = $(".home_jackets_section .counter .first");
	    gsap.set([content2, content3, content4, content5],{autoAlpha:0});

	    var current = content1;


	    $(".home_jackets_section nav .arrow-down").click(function() {
     
	        var prev = current.prev('.feature-row__item_item');
	        var lengthNumber = parseInt(prev.length);
	        var counterLabel = prev.attr('data-number');
	        counterLabel = "0"+counterLabel;

	        if ( current != content1 && lengthNumber == 1 ){

	            if ( counterLabel == "02" ){

	                /*let tl = gsap.timeline();
	                    tl.to(imageCoatBox, {scale:3, ease: "expoScale(0.1, 3)"}, 0)
	                      .to(imageCoat, {xPercent: -10, yPercent: -25}, 0);*/

	            }else if ( counterLabel == "03" ){

	                //gsap.to(imageCoat, {xPercent: 25, yPercent: -40});

	            }else if ( counterLabel == "01" ){

	                /*let tl = gsap.timeline();
	                    tl.to(imageCoatBox, {scale:1, ease: "expoScale(0.1, 1)"}, 0)
	                      .to(imageCoat, {xPercent: 0, yPercent: 0}, 0);*/
	                
	            }

	            gsap.to(current, {autoAlpha:0});
	            gsap.to(prev, {autoAlpha:1});
	            counter.html(counterLabel);
	            current = prev;

	        }else{

	            current = content1;

	        }

	        

	    });


	    $(".home_jackets_section nav .arrow-up").click(function() {

			console.log("arrow up");
	            
	        var next = current.next();
	        var lengthNumber = parseInt(next.length);
	        var counterLabel = next.attr('data-number');
	        counterLabel = "0"+counterLabel;

	        if ( current != content5 && lengthNumber == 1 ){

	            gsap.to(current, {autoAlpha:0});
	            gsap.to(next, {autoAlpha:1});
	            counter.html(counterLabel);

	            // if ( counterLabel == "02" ){

	            //     let tl = gsap.timeline();
	            //         tl.to(imageCoatBox, {scale:3, ease: "expoScale(0.1, 3)"}, 0)
	            //           .to(imageCoat, {xPercent: -10, yPercent: -25}, 0);

	            // }else if ( counterLabel == "03" ){

	            //     gsap.to(imageCoat, {xPercent: 25, yPercent: -40});

	            // }else if ( counterLabel == "04" ){

	            //     gsap.to(imageCoat, {xPercent: 0, yPercent: 40});

	            // }

	            current = next;

	        }else{

	            current = content5;

	        }

	        

	    });

 	}


    if ( $('.home-caroussel').length ) {


        var $homeslider = $('.home-caroussel');
        $homeslider.slick({
            slidesToShow: 1,
            infinite: false,
            swipeToSlide: true,
            variableWidth: true,
            variableHeight: true,
            slidesToScroll: 1,
            accessibility: false,
            dots: false,
            prevArrow: false,
            nextArrow: false,
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });


        $(".nav-home-caroussel li:first-of-type").addClass("active");
		var initLinked = $(".nav-home-caroussel").find(".home-caroussel:first-of-type").attr('data-slider-item');
	    $(".control-home-caroussel .control").attr('current_caroussel',initLinked);

	    $(".nav-home-caroussel li a").click(function(event) {
	    	event.preventDefault();
	        if ($(this).closest("li").hasClass("active")) {
	            return false;
	        }
	        let tl = gsap.timeline();
	        $(".nav-home-caroussel li").removeClass("active");
	        $(this).closest("li").addClass("active");


	        var linkClicked = "collection-"+$(this).attr("data-title-slider");
	        var onLinked = "collection-"+$(this).attr('data-title-slider');


	        $(".control-home-caroussel .control").attr('current_caroussel',onLinked);

	        var caroussel = $(".home-caroussel."+linkClicked+"");

	        tl.to(".home-caroussel", {duration: 0.3, autoAlpha:0, x:100}, 0)
	        tl.to(".home-caroussel", {duration: 0, display:"none"}, 0.3)
	        tl.to(caroussel, {duration: 0, display:"block"}, 0.3)
	        tl.to(caroussel, {duration: 0.3, autoAlpha:1, x:0}, 0.3)
	        return tl;
		});


        $(".control-home-caroussel .control-prev").click(function(){

            var classe = $(this).attr('current_caroussel');

            if ( $homeslider.hasClass(classe) ){

                $(".home-caroussel."+classe).slick('slickPrev');

            }

        });

        $(".control-home-caroussel .control-next").click(function(){

            var classe = $(this).attr('current_caroussel');

            if ( $homeslider.hasClass(classe) ){

                $(".home-caroussel."+classe).slick('slickNext');

            }

        });

    }


    /* Slider image social */


    if ( $(".image_slider").length ){

    	 var $image_slider = $('.image_slider .inner_image_slider');

    	 $image_slider.slick({
            slidesToShow: 1,
            infinite: false,
            swipeToSlide: true,
            variableWidth: true,
            variableHeight: true,
            slidesToScroll: 1,
            accessibility: false,
            dots: false,
            prevArrow: false,
            nextArrow: false,
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    	 

    }



    /*-*-----------*/


    /* Accordion */

    if ( $(".accordion-fosfo").length ){

        $(".accordion-fosfo").each(function(){

             if ( $(this).hasClass('accordion-single-only') ) {

                $(".accordion_item").each(function(){

                    $(this).find('.title').on('click', function(){

                        var thisParent = $(this).parents(".accordion-single-only");

                        thisParent.find('.title').not($(this)).removeClass('title_open');
                        $(this).toggleClass('title_open');
                        thisParent.find('.content').not($(this).parent().find('.content')).removeClass('content-open').stop().slideUp();
                        $(this).parent().find('.content').toggleClass('content-open').stop().slideToggle();

                    });

                });

            }else{

                $(".accordion_item").each(function(){

                    $(this).find('.title').on('click', function(){

                        $(this).toggleClass('title_open');
                        $(this).parent().find('.content').toggleClass('content-open').stop().slideToggle();

                    });

                });

            }

        });


    }

    /*-----------*/


    /* Slick caractéristiques */


    /*if ($("#head-c").length) {
        $("#head-c").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            accessibility: true,
            variableWidth: true,
            variableHeight: true,
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }*/


    /*-------------------------*/


    /* Formulaire de contact Fosfo */


    if ( $("#request-select").length && $("#dynamic-response-select").length ) {

        var requestSelect = $("#request-select");
        var dynamicResponseSelect = $("#dynamic-response-select");

        requestSelect.find('#choose-a-request-type').on('change', function(){

            var thisValue = this.value;
            thisValueFormated = thisValue.replace(/ /g, '-');
            thisValueFormated = thisValueFormated.replace(/&/g,'');
            thisValueFormated = thisValueFormated.replace(/\//g,'');
            thisValueFormated = thisValueFormated.replace(/--/g,'-');
            thisValueFormated = thisValueFormated.toLowerCase();
            
            var thisDynamicAssociated = dynamicResponseSelect.find("select[data-id='"+thisValueFormated+"']");

            dynamicResponseSelect.find('select').not(thisDynamicAssociated).hide();
            thisDynamicAssociated.show();


        });

    }


    /*------------------------------*/


    /* Filter Tags Blog */


    if ( $(".blog-template-fosfo").length ){


        var blogTagFilterParent = $(".blog_tag_filter");

        blogTagFilterParent.on('click', 'a', function(e){

            e.preventDefault();
            var thisA = $(this);

            if ( thisA.hasClass('current') ){
                return false;
            }

            blogTagFilterParent.find('a').not(thisA).removeClass('current');
            thisA.addClass('current');
            $("#preloader_ajax").fadeIn(function(){

                setTimeout(function(){

                    var dataTagA = thisA.attr('data-tag');
                    dataTagA = dataTagA;

                    var gridContainer = $(".grid-blog-fosfo");

                    if ( dataTagA == "All" ){

                        gridContainer.find(".grid__item_article").show(function(){
                            $("#nb_result").text($("#total_post").text());
                            $("#preloader_ajax").fadeOut();
                        });

                    }else{

                        gridContainer.find(".grid__item_article").hide();
                        var lenghtArticles = gridContainer.find(".grid__item_article[data-tag*="+dataTagA+"]").length;
                        gridContainer.find(".grid__item_article[data-tag*="+dataTagA+"]").show(function(){
                            $("#nb_result").text(lenghtArticles);
                            $("#preloader_ajax").fadeOut();
                        });

                    }

                }, 1000);

            });



        });


    }


    /*-------------------*/


    /* Hamburger Menu */

    if ( $("#cu_hamburger_bull").length ){

        function burgerClose(tThis){

            $("body, html").removeClass('menu-open');
            tThis.removeClass('burger-open');
            $(".hide-on-hamburger-open").css("display", "block");
            $(".visible-on-hamburger-open").css("display", "none");
            $("#secondary-nav").fadeOut();
            $("#SiteHeader").removeClass('burger-open');
            $(".multi-selectors__item").removeClass('open');

        }

        function burgerOpen(tThis){

            $("body, html").addClass('menu-open');
            tThis.addClass('burger-open');
            $(".hide-on-hamburger-open").css("display", "none");
            $(".visible-on-hamburger-open").css("display", "block");
            $("#secondary-nav").fadeIn();
            $("#SiteHeader").addClass('burger-open');
            $(".multi-selectors__item").addClass('open');

        }

        $("#cu_hamburger_bull").on('click', function(event){


            event.preventDefault();

            if ( $(this).hasClass('burger-open') ) {

                burgerClose($(this));

            }else{

                burgerOpen($(this));

            }


        });


        $("li.title_menu_mobile").on('click','a',function(event){

            var fosfoWindow = $(window).width();

            if ( fosfoWindow > 767 ){

                return false;

            }

            event.preventDefault();
            $(this).toggleClass('open');
            $(this).parents(".menu").find('.li_with_sub').stop().slideToggle();

        });

        $(".menu_help").on('click','.title', function(){

            var fosfoWindow = $(window).width();

            if ( fosfoWindow > 767 ){

                return false;

            }

            $(this).toggleClass('open');
            $(this).parents(".menu").find('.li_with_sub').stop().slideToggle();

        });


    }

    /*-----------------*/


    /* Mega menu */


    $("#HeaderWrapper").on('focusin mouseover', '.site-nav--has-dropdown', function(){

        $("body").addClass('mega-is_open');
        $("#SiteHeader").addClass('mega-menu-focus');
        if ( $("#cu_hamburger_bull").hasClass('burger-open') ) {
            burgerClose($("#cu_hamburger_bull"));
        }
        $(".multi-selectors__item").addClass('open');

    });

    $("#HeaderWrapper").on('mouseleave', '.site-nav--has-dropdown', function(){

        $("body").removeClass('mega-is_open');
        $("#SiteHeader").removeClass('mega-menu-focus');
        $(".multi-selectors__item").removeClass('open');

    });


    /*-----------*/


    /* Slide details product */

    if ( $(".fosfo_custom_section").length ){


        var fosfoDetailsSlider = $(".fosfo_custom_section .slider");

        fosfoDetailsSlider.slick({

            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 400,
            autoplay: false,
            loop: true,
            accessibility: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode:true
                    }
                },
            ]
        });


        if ($(".fosfo_custom_section .rl").length && $(".fosfo_custom_section .slick-prev").length) {
            $(".fosfo_custom_section .rl").click(function () {
                $(".fosfo_custom_section .slick-prev").click();
            });
        }
        if ($(".fosfo_custom_section .rr").length && $(".fosfo_custom_section .slick-next").length) {
            $(".fosfo_custom_section .rr").click(function () {
                $(".fosfo_custom_section .slick-next").click();
            });
        }


        var $progressBarDetails = $('.fosfo_custom_section .progress');
        var iCompteur = parseInt($('.fosfo_custom_section .inner_slider').length);
        var percentProgress = 100 / iCompteur;
        $progressBarDetails.css('background-size', percentProgress+'% 100%').attr('aria-valuenow', percentProgress);

        fosfoDetailsSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var calc = (((nextSlide) / (slick.slideCount - 1)) * 100) + percentProgress;
            $progressBarDetails
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
        });


    }



    /*------------------------*/


    /* Gallery images */

    if ( $(".gallery-images").length ) {

        $('.popup-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            }
        });

    }    

    /*-----------------*/


    /* Video controls */

    if ( $("#collection-september").length ) {

        $(".custom_controler_video").on('click', function(){

            var video = $(this).parent().find('video');
          
            if ( $(this).hasClass('paused') ){
               video.get(0).play();
               $(this).removeClass('paused');
            }else{
              video.get(0).pause();
              $(this).addClass('paused');
            }

        });

    }

    /*------------------*/


  /* Custom switcher Mobile */

  $(".switcher_mobile").on('click', '.custom_switcher', function(e){

      e.preventDefault();
      var thisLang = $(this).attr("data-lang");
      var switchL = $('.disclosure-list__option[lang="'+thisLang+'"]');
      switchL.addClass('custom_trigger');
      setTimeout(function(){
        switchL.click();
      },100);
    
  });
  
  /*--------------------------*/


});